module.exports = __webpack_public_path__ + "static/media/workPvcCeilings18.08e71d6e.jpg";